/**
 * Страны серверов: ряд флагов и подпись.
 *
 * Пока узлов нет, список задан вручную (SERVER_COUNTRIES). Когда появится
 * панель Remnawave, он будет приходить из API вместе с узлами — тогда же
 * блок станет ссылкой на экран серверов. До этого стрелки «Все ›» нет:
 * она обещала бы переход, которого нет.
 */
import { Flag, type CountryCode } from './Flag';
import { Icon } from './Icon';
import styles from './Servers.module.css';

/** Страны, где будут узлы. Временно: заменится списком из панели. */
export const SERVER_COUNTRIES: readonly CountryCode[] = ['nl', 'de', 'us', 'ru', 'pl', 'ee'];

export function Servers({
  countries = SERVER_COUNTRIES,
  embedded = false,
}: {
  countries?: readonly CountryCode[];
  /** Внутри другой карточки: без своей подложки, с линией сверху. */
  embedded?: boolean;
}) {
  return (
    <section className={embedded ? styles.embedded : styles.card} aria-label="Страны серверов">
      <div className={styles.flags}>
        {countries.map((code) => (
          <Flag key={code} code={code} size={28} />
        ))}
      </div>
      <div className={styles.footer}>
        <span className={styles.title}>
          <span className={styles.bolt}>
            <Icon name="bolt" size={14} />
          </span>
          Быстрые серверы
        </span>
      </div>
    </section>
  );
}
